import { createAuth0 } from '@auth0/auth0-vue';
import { authConfig } from './shared/config/auth.config';

export const Auth0Instance = createAuth0(authConfig);